// src/context/LibraryContext.js
import { createContext, useContext, useMemo } from 'react';
import useIDBState from '../utils/useIDBState';

/** IndexedDB key ⇒ keeps the library across projects & sessions */
const KEY = 'uvalueLibrary';

const Ctx = createContext({ library: [], setLibrary: () => { } });

export function LibraryProvider({ children }) {
    /* array of saved ConstructionCards (clean clones, see step 3) */
    const [library, setLibrary] = useIDBState(KEY, []);

    const value = useMemo(() => ({ library, setLibrary }), [library, setLibrary]);
    return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useLibrary = () => useContext(Ctx);
